export const LIMIT = 10;
export const UPLOAD_CONST = "";
// export const URI = "http://localhost:5000";
export const URI = "https://api.fairleadertechnologies.com";
export const ROLES = ["SUPER_ADMIN", "AGENT", "TL"];
